import { IconButton } from "@material-ui/core";
import { MyLocation, PhoneInTalk, PhoneIphone } from "@material-ui/icons";
import React from "react";
import './index.css'

const Information = () => {
  const information = [
    {
      title: "آدرس",
      icon: MyLocation,
      value:
        "تهران : پونک، انتهای بزرگراه اشرفی اصفهانی ، نرسیده به خیابان سیمون بولیوار ، پلاک 306 ، ساختمان عمارت باختر ، طبقه سوم واحد 5 کدپستی : 1477686366",
    },
    { title: "تلفن همراه", icon: PhoneIphone, value: "09378244400" },
    { title: "تلفن ثابت", icon: PhoneInTalk, value: "02144855176" },
  ];
  return (
    <div className="information mt-5 flex column full-width">
      {information.map((item, index) => (
        <div key={index} className="flex align-center my-1">
          <IconButton>{React.createElement(item.icon)}</IconButton>
          <span
            dir={item.type === Number ? "ltr" : "rtl"}
            className="text-large flex-1"
          >
            {item.value}
          </span>
        </div>
      ))}
    </div>
  );
};

export default Information;
